import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.1.0";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import 'sweetalert/dist/sweetalert.css';
import "assets/webGestor/webGestor.css";

const hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/painelwebgestor/auth" render={props => <AuthLayout {...props} />} />
      <Route path="/painelwebgestor/admin" render={props => <AdminLayout {...props} />} />
      <Redirect to="/painelwebgestor/auth/login" />
    </Switch>
  </Router>,
  document.getElementById("root")
);